var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85355 13.1464C0.0112493 10.3041 0.0112491 5.69586 2.85355 2.85355C5.69586 0.0112495 10.3041 0.0112495 13.1464 2.85355C15.9888 5.69586 15.9888 10.3041 13.1464 13.1464C10.3041 15.9888 5.69586 15.9888 2.85355 13.1464ZM4.64645 4.04645L4.04645 4.64645C3.74073 4.95217 3.74073 5.44783 4.04645 5.75355L6.29289 8L4.04645 10.2464C3.74073 10.5522 3.74073 11.0478 4.04645 11.3536L4.64645 11.9536C4.95217 12.2593 5.44783 12.2593 5.75355 11.9536L8 9.70711L10.2464 11.9536C10.5522 12.2593 11.0478 12.2593 11.3536 11.9536L11.9536 11.3536C12.2593 11.0478 12.2593 10.5522 11.9536 10.2464L9.70711 8L11.9536 5.75355C12.2593 5.44783 12.2593 4.95217 11.9536 4.64645L11.3536 4.04645C11.0478 3.74073 10.5522 3.74073 10.2464 4.04645L8 6.29289L5.75355 4.04645C5.44783 3.74073 4.95217 3.74073 4.64645 4.04645Z",
    stroke: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6e270bf4.svg";
export { ForwardRef as ReactComponent };